const monthLetters = {
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
  H: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
};

const yearMonthPattern = /^(?!00)[0-9]{2}[A-HJ-M]$/i;

export function useSDCValidation(serialNumberSubmit, isSDCItem) {
  if (!isSDCItem || serialNumberSubmit.length < 3) {
    return { invalidSDCFormat: false };
  }

  const rawYYM = serialNumberSubmit.slice(0, 3);
  const isPatternValid = yearMonthPattern.test(rawYYM);

  const yy = parseInt(rawYYM.slice(0, 2), 10);
  const mm = monthLetters[rawYYM.charAt(2).toUpperCase()];
  const now = new Date();
  const thisCentury = Math.floor(now.getFullYear() / 100) * 100;
  const fullYear = thisCentury + yy;

  const isFuture =
    fullYear > now.getFullYear() ||
    (fullYear === now.getFullYear() && mm > now.getMonth() + 1);

  return { invalidSDCFormat: !isPatternValid || isFuture };
}
